import { Component, OnInit } from '@angular/core';
import { BaseDataService, BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { Izvod } from './izvod';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'yt-izvod-tabs',
  templateUrl: './izvod-tabs.component.html',
  providers: [
    TabsContainerService
]
})
export class IzvodTabsComponent extends BaseTabsContainer<Izvod> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<Izvod>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) {
    super(tabsContainerService, activatedRoute, userService);
   }

  ngOnInit() {
    super.ngOnInit();
  }  

}
